import { render, staticRenderFns } from "./dictionaryList.vue?vue&type=template&id=22f1fd96"
import script from "./dictionaryList.vue?vue&type=script&lang=js"
export * from "./dictionaryList.vue?vue&type=script&lang=js"
import style0 from "./dictionaryList.vue?vue&type=style&index=0&id=22f1fd96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports